export enum PARAM_SORT {
  LATEST = 'date,desc',
  END_DATE = 'date,asc',
  REVENUE_RATE = 'revenueRate,desc',
  COUNT = 'count,desc',
  REMAIN = 'count,asc',
  PROFIT_DESC = 'revenueRate,desc',
  PROFIT_ASC = 'revenueRate,asc',
  DESC = 'createdDate,desc', // FIXME : 확인 후 sort 코드 통일 필요
  ASC = 'createdDate,asc', // FIXME : 확인 후 sort 코드 통일 필요
}

export enum PARAM_FILTER {
  ALL = 'ALL',
  ALL_LOW = 'all',
  SALE = 'SALE',
  SALE_LOW = 'sale',
  BUY = 'BUY',
  TRADE_BUY = 'trade.buy',
  SELL = 'SELL',
  TRADE_SELL = 'trade.sell',
  TRANSFER = 'walletTransfer',
  DESTRUCT = 'destruct',
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  REVENUE = 'REVENUE',
  REFUND = 'REFUND',
  REFUND_LOW = 'refund',
  FAVORITE = 'FAVORITE',
  MINE = 'MINE',
  DONE = 'DONE', // FIXME : PARAM이 아닌 탭을 선택하기 위한 타입
  YET = 'YET', // FIXME : PARAM이 아닌 탭을 선택하기 위한 타입
}
